import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Toast, ToasterService } from 'angular2-toaster';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LocalizedToasterService extends ToasterService {
    constructor(private translate: TranslateService) { super(); }

    public pop(type: string | Toast, title?: string, body?: string) {
        let translatedTitle = title ? this.translate.instant(title) : undefined;
        let translatedBody = body ? this.translate.instant(body) : undefined;
        return super.pop(type, translatedTitle, translatedBody);
    }

    public popAsync(type: string | Toast, title?: string, body?: string) {
        return Observable.create(async observer => {
            try {
                let translatedTitle = title ? await this.translate.get(title).toPromise() : undefined;
                let translatedBody = body ? await this.translate.get(body).toPromise() : undefined;
                let toaster = super.popAsync(type, translatedTitle, translatedBody);
                observer.next(toaster);
                observer.complete();
            } catch (e) {
                observer.error(e);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/localizedToasterService.ts